import styled, { css } from 'styled-components';

import { SubNavContainer } from './sidebar.sc';

const SearchContainer = styled.div<{ $focused: boolean }>`
  display: ${({ $focused }) => ($focused ? 'block' : 'none')};
`;

export const IconWrapper = styled.div`
  height: 100%;
`;

export const Container = styled.div<{ $isSelected: boolean }>(
  ({ $isSelected, theme }) => css`
    height: 60px;
    width: 60px;
    cursor: pointer;
    font-size: 15px;
    position: relative;
    background: ${$isSelected ? theme.white.a10 : 'transparent'};

    &:hover {
      background: ${theme.white.a10};
      ${SubNavContainer} {
        display: block;
      }
      ${SearchContainer} {
        display: none;
      }
    }

    &:nth-child(1) {
      background: ${$isSelected ? theme.white.a10 : 'linear-gradient(46deg, #4c5269, #636a87)'};
      border: none;
      cursor: pointer;

      &:hover {
        box-shadow: 0 -1px 54px -11px rgba(0, 0, 0, 0.75);
        background-image: none;
      }
    }

    @media (max-height: 420px) {
      height: auto;
      padding: 10px;
    }
  `,
);

export const RedDot = styled.div`
  height: 10px;
  width: 10px;
  position: absolute;
  top: 13px;
  right: 13px;
  background-color: ${({ theme }) => theme.red.a10};
  border-radius: 10px;
`;
